export function createPendingEdits() {
  const edits = new Map<string, () => void>();
  const listeners = new Set<() => void>();
  const notify = () => listeners.forEach(listener => listener());
  return {
    set(key: string, flush: () => void) { edits.set(key, flush); notify(); },
    remove(key: string) { if (edits.delete(key)) notify(); },
    flush() { [...edits.values()].forEach(flush => flush()); },
    getSnapshot: () => edits.size > 0,
    subscribe(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; },
  };
}
export type PendingEdits = ReturnType<typeof createPendingEdits>;
